var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGpsSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 9.33333C1 9.65442 1.2603 9.91475 1.58139 9.91475H3.15868C3.43398 12.8757 5.79095 15.2327 8.75192 15.508V17.0852C8.75192 17.4063 9.01225 17.6667 9.33333 17.6667C9.65442 17.6667 9.91475 17.4063 9.91475 17.0852V15.508C12.8757 15.2327 15.2327 12.8757 15.508 9.91475H17.0852C17.4063 9.91475 17.6667 9.65442 17.6667 9.33333C17.6667 9.01225 17.4063 8.75192 17.0852 8.75192H15.508C15.2327 5.79095 12.8757 3.43398 9.91475 3.15868V1.58139C9.91475 1.2603 9.65442 1 9.33333 1C9.01225 1 8.75192 1.2603 8.75192 1.58139V3.15868C5.79095 3.43398 3.43398 5.79095 3.15868 8.75192H1.58139C1.2603 8.75192 1 9.01225 1 9.33333ZM6.42636 9.33333C6.42636 7.72783 7.72783 6.42636 9.33333 6.42636C10.9388 6.42636 12.2403 7.72783 12.2403 9.33333C12.2403 10.9388 10.9388 12.2403 9.33333 12.2403C7.72783 12.2403 6.42636 10.9388 6.42636 9.33333Z",
    fill: "#2C963D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58887 9.33403C7.58887 8.37078 8.3698 7.58984 9.33305 7.58984C10.2963 7.58984 11.0772 8.37078 11.0772 9.33403C11.0772 10.2973 10.2963 11.0782 9.33305 11.0782C8.3698 11.0782 7.58887 10.2973 7.58887 9.33403Z",
    fill: "#2C963D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsSvgrepoCom);
export default __webpack_public_path__ + "static/media/gps-svgrepo-com.fc2f44ba31dd6a29f72179244a52b242.svg";
export { ForwardRef as ReactComponent };